import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';
import { MdbTimepickerModule } from 'mdb-angular-ui-kit/timepicker';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule  } from 'ngx-quill'
import Counter from './features//counter';

import { ActivityTimerPipe } from './pipes/activity-timer.pipe';

import { WidgetComponent } from './components/widget/widget.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ErrorInterceptor } from './interceptors/error.interceptor';
import { ConfirmComponent } from './components/modals/confirm/confirm.component';
import { StoreModule } from '@ngrx/store';
import * as fromWidget from './features/layout.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LayoutEffects } from './features/layout.effects';
import { LayoutComponent } from './components/layout/layout.component';
import { CropperComponent } from './components/modals/cropper/cropper.component';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { InputFileComponent } from './components/input-file/input-file.component';
import { FormImgComponent } from './components/form-img/form-img.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { DatetimeComponent } from './components/datetime/datetime.component';
import { AdditionaGuestInfoComponent } from './components/modals/additiona-guest-info/additiona-guest-info.component';
import { FormFieldComponent as FormFieldModalComponent } from './components/modals/form-field/form-field.component';
import { TicketComboComponent } from './components/modals/ticket-combo-modal/ticket-combo-modal.component';
import { InputComponent } from './components/input/input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { LearnMoreComponent } from './components/modals/learn-more/learn-more.component';
import { VideoComponent } from './components/modals/video/video.component';
import { MoveToComponent } from './components/move-to/move-to.component';
import { CookieService } from 'ngx-cookie-service';
import { FileDropComponent } from './components/file-drop/file-drop.component';
import { ActionSuccessComponent } from './components/modals/action-success/action-success.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { NumbersOnlyDirective } from '../core/directives/numbers-only.directive';
import * as fromUser from './features/user/user.reducer';
import { UserEffects } from './features/user/user.effects';
import { UserService } from './services/user.service';

import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from "ngx-currency";
import { ShowAnonymousComponent } from './components/modals/show-anonymous/show-anonymous.component';
import { TotalItemCountHelpComponent } from './components/modals/total-item-count-help/total-item-count-help.component';
import { FaqInfoComponent } from './components/modals/faq-info/faq-info.component';
import { RaffleDrawComponent } from './components/modals/raffle-draw/raffle-draw.component';
import { RegistrationButtonDialogComponent } from './components/modals/registration-button-dialog/registration-button-dialog.component';
import { ReadMoreComponent } from './components/read-more/read-more.component';
import { createCustomElement } from '@angular/elements';
import { InputMaskModule } from '@ngneat/input-mask';
import { StreamHelpComponent } from './components/modals/stream-help/stream-help.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PaybeeStreamModalComponent } from './components/modals/paybee-stream-modal/paybee-stream-modal.component';
import { MdbpInputComponent } from './components/mdb-input/mdb-input.component';
import { MdbTextareaComponent } from './components/mdb-textarea/mdb-textarea.component';
import { MdbSwitchComponent } from './components/mdb-switch/mdb-switch.component';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { ChipsComponent } from './components/chips/chips.component';
import { IconModule } from '../icon/icon.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { ChipsAutocompleteComponent } from './components/chips-autocomplete/chips-autocomplete.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { DatepickerChipsComponent } from './components/datepicker-chips/datepicker-chips.component';

import { SafePipe } from '../event/pipes/safe.pipe';
import { VideoModalComponent } from './components/modals/video-modal/video-modal.component';
import { TextPopoverComponent } from './components/text-popover/text-popover.component';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { StreamPreviewComponent } from './components/modals/stream-preview/stream-preview.component';
import { FileLoadingComponent } from './components/file-loading/file-loading.component';
import { TextDialogComponent } from './components/modals/text-dialog/text-dialog.component';
import { BidConfirmComponent } from './components/modals/bid-confirm/bid-confirm.component';
import { CopyCampaignComponent } from './components/modals/copy-campaign/copy-campaign.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CounterModule } from './modules/counter/counter.module';
import { QuillCustomComponent } from './components/quill-custom/quill-custom.component';
import { ConfirmModalComponent } from './components/modals/confirm-modal/confirm-modal.component';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { P2pAmountOptionComponent } from './components/modals/p2p-amount-option/p2p-amount-option.component';
import { P2pPercentOptionComponent } from './components/modals/p2p-percent-option/p2p-percent-option.component';
import { TeamInfoComponent } from './components/modals/team-info/team-info.component';
import { ButtonComponent } from './embedded/button/button.component';
import { IframeComponent } from './embedded/iframe/iframe.component';
import { CustomInputFileComponent } from './components/custom-input-file/custom-input-file-component';
import { CustomReminderComponent } from './components/custom-reminder/custom-reminder.component';
import { MdbInputGoogleMapsAutocompleteComponent } from './components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';

@NgModule({
  declarations: [        
    FormImgComponent,
    FormFieldComponent,
    ChipListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromWidget.layoutFeatureKey, fromWidget.reducer),
    StoreModule.forFeature(fromUser.userFeatureKey, fromUser.reducer),
    EffectsModule.forFeature([LayoutEffects, UserEffects]),
    AngularCropperjsModule,
    MdbPopoverModule,
    MdbFormsModule,
    MdbDatepickerModule,
    MdbCheckboxModule,

    MdbTimepickerModule,
    NgxFileDropModule,
    InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true }),
    ClipboardModule,
    IconModule,
    MdbAutocompleteModule,
    MdbSelectModule,
    QuillModule.forRoot({
      customModules: [{
        implementation: Counter,
        path: 'modules/counter'
      }]
    }),
    NgxPaginationModule,
    CounterModule,
    MdbTabsModule,
    MdbTooltipModule,
    NgxCurrencyDirective,
    MdbInputGoogleMapsAutocompleteComponent,
    ChipsComponent,
    ChipsAutocompleteComponent,
    CustomInputFileComponent,
    CustomReminderComponent,
    MdbpInputComponent,
    QuillCustomComponent,
    DatepickerComponent,
    DatepickerChipsComponent,
    DatetimeComponent,
    FileDropComponent,
    FileLoadingComponent,
    HeaderComponent,
    InputComponent,
    MoveToComponent,
    WidgetComponent,
    ConfirmComponent,
    LayoutComponent,
    CropperComponent,
    InputFileComponent,
    AdditionaGuestInfoComponent,
    TicketComboComponent,
    TextareaComponent,
    LearnMoreComponent,
    VideoComponent,
    ActionSuccessComponent,
    LoadingComponent,
    NumbersOnlyDirective,
    ShowAnonymousComponent,
    FaqInfoComponent,
    RaffleDrawComponent,
    RegistrationButtonDialogComponent,
    ReadMoreComponent,
    StreamHelpComponent,
    PaybeeStreamModalComponent,
    MdbTextareaComponent,
    MdbSwitchComponent,
    IframeComponent,
    ButtonComponent,
    TeamInfoComponent,
    P2pPercentOptionComponent,
    P2pAmountOptionComponent,
    ConfirmModalComponent,
    CopyCampaignComponent,
    SafePipe,
    ActivityTimerPipe,
    BidConfirmComponent,
    TextDialogComponent,
    StreamPreviewComponent,
    TextPopoverComponent,
    VideoModalComponent,
    TotalItemCountHelpComponent,
    FormFieldModalComponent,
  ],
  providers: [
    provideEnvironmentNgxCurrency({
      align: "left",
      allowNegative: false,
      allowZero: true,
      decimal: ".",
      precision: 0,
      prefix: "$ ",
      suffix: "",
      thousands: ",",
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial
    }),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CookieService,
    UserService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ActivityTimerPipe, MoveToComponent, WidgetComponent, ConfirmComponent, LayoutComponent, InputFileComponent, CustomInputFileComponent, ChipListComponent, DatetimeComponent, InputComponent, TextareaComponent, DatepickerComponent, FileDropComponent, HeaderComponent, LoadingComponent, NumbersOnlyDirective, ShowAnonymousComponent, TotalItemCountHelpComponent, ReadMoreComponent, MdbpInputComponent, MdbTextareaComponent, MdbSwitchComponent, ChipsComponent, ChipsAutocompleteComponent, DatepickerChipsComponent, SafePipe, TextPopoverComponent, FileLoadingComponent,QuillCustomComponent, P2pAmountOptionComponent,
    P2pPercentOptionComponent, TeamInfoComponent, ButtonComponent, IframeComponent]

})
export class CoreModule {
  constructor(injector: Injector) {
    const MdbInputElement = createCustomElement(MdbpInputComponent, { injector });
    const CustomReminderModal = createCustomElement(CustomReminderComponent, { injector });

    try {
      customElements.define('paybee-mdb-input-element', MdbInputElement);
      customElements.define('custom-reminder-modal-element', CustomReminderModal);
    } catch (e) {
    }
  }
}
